import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.328 19.548l-3.74-3.74-1.215 3.639-.712-.238.712.238v.001c-.67 1.995-3.486 2.078-4.231.081l-2.197-5.492-5.493-2.188c-1.981-.744-1.92-3.57.092-4.241l3.634-1.21-3.725-3.725 1.06-1.061 16.875 16.875-1.06 1.06zm-6.377-.577l1.451-4.349-7.038-7.038L5.019 9.03c-.685.228-.686 1.174-.036 1.415l.008.004 6.107 2.432 2.444 6.109.003.01c.24.651 1.176.651 1.406-.03z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.65 12.627l2.223-6.66v-.002c.584-1.767-1.094-3.432-2.848-2.847l-6.665 2.22 1.186 1.186L18.5 4.54a.752.752 0 01.95.952l-1.985 5.949 1.186 1.185z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.328 19.548l-3.74-3.74-1.215 3.639-.712-.238.712.238v.001c-.67 1.995-3.486 2.078-4.231.081l-2.197-5.492-5.493-2.188c-1.981-.744-1.92-3.57.092-4.241l3.634-1.21-3.725-3.725 1.06-1.061 16.875 16.875-1.06 1.06zm-6.377-.577l1.451-4.349-7.038-7.038L5.019 9.03c-.685.228-.686 1.174-.036 1.415l.008.004 6.107 2.432 2.444 6.109.003.01c.24.651 1.176.651 1.406-.03z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.65 12.627l2.223-6.66v-.002c.584-1.767-1.094-3.432-2.848-2.847l-6.665 2.22 1.186 1.186L18.5 4.54a.752.752 0 01.95.952l-1.985 5.949 1.186 1.185z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42.655 39.095l-7.48-7.48-2.429 7.278-1.423-.474 1.423.474-.001.004c-1.34 3.989-6.97 4.155-8.462.162L19.89 28.074 8.903 23.7c-3.961-1.488-3.84-7.141.186-8.483l7.266-2.42-7.45-7.45 2.121-2.122 33.75 33.75-2.121 2.121zm-12.754-1.154l2.904-8.696-14.078-14.077-8.69 2.894c-1.368.457-1.372 2.348-.072 2.83l.017.007 12.215 4.865 4.887 12.217.007.02c.48 1.304 2.351 1.303 2.81-.06z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.3 25.254c1.99-5.96 3.98-11.92 4.446-13.32l.001-.004c1.168-3.534-2.189-6.864-5.698-5.694l-13.328 4.44 2.372 2.371 11.905-3.965c1.17-.39 2.292.719 1.901 1.905l-3.97 11.896 2.37 2.371z"
  }))
};
export var NavigationNull = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});